import React from 'react';
import { Skeleton } from '@mui/material';
import { Stack } from '@eds-web/react';
import styled from '@emotion/styled';

export const StyledStack = styled(Stack)`
    display: flex;
    justify-content: center;
    .MuiSkeleton-root {
        background-color: rgb(230 230 234 / 11%);
        &::after {
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.04), transparent);
        }
    }
`;

export const PriceSkeleton = () => (
    <>
        <PrizeSkeletonColumn />
        <PrizeSkeletonColumn />
        <PrizeSkeletonColumn />
        <PrizeSkeletonColumn />
        <PrizeSkeletonColumn />
    </>
);

const PrizeSkeletonColumn = () => (
    <StyledStack style={{ height: 50 }} gap={16}>
        <Skeleton variant="rectangular" width={99} height={33} animation="wave" />

        <Skeleton width={120} height={20} animation="wave" />

        <Skeleton variant="text" width={80} height={20} animation="wave" />

        <Skeleton variant="text" width={60} height={20} animation="wave" />

        <Skeleton variant="text" width={70} height={20} animation="wave" />

        <Skeleton variant="text" width={60} height={20} animation="wave" />

        <Skeleton variant="text" width={70} height={20} animation="wave" />
    </StyledStack>
);
